module.exports = __webpack_public_path__ + "img/d5c0782da13a41c787a681e12816b976.png";